export const mobileMenu = () => {
	const menuBtn = document.querySelector('.header-mobile #open-menu');

	if (menuBtn) {
		menuBtn.addEventListener('click', function () {
			document.querySelector('.mega-menu-wrap .mega-menu-toggle').classList.toggle("mega-menu-open");
		})
	}
}






